module.exports = __webpack_public_path__ + "static/media/ua.5516d9ea.svg";